import React, { useState } from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const sections = [
    {
      id: 'collection',
      title: 'Information We Collect',
      icon: '📋',
      content: [
        {
          subtitle: 'Device Information',
          text: 'When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site.'
        },
        {
          subtitle: 'Collection Technologies',
          text: 'We collect Device Information using the following technologies:',
          list: [
            'Cookies are data files that are placed on your device or computer and often include an anonymous unique identifier.',
            'Log files track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.',
            'Web beacons, tags, and pixels are electronic files used to record information about how you browse the Site.'
          ]
        },
        {
          subtitle: 'Order Information',
          text: 'When you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, billing address, shipping address, payment information (including credit card numbers), email address, and phone number.'
        }
      ]
    },
    {
      id: 'usage',
      title: 'How We Use Your Information',
      icon: '🎯',
      content: [
        {
          subtitle: 'Order Information',
          text: 'We use the Order Information that we collect generally to fulfil any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations). Additionally, we use this Order Information to:',
          list: [
            'Communicate with you',
            'Screen our orders for potential risk or fraud',
            'When in line with your preferences, provide you with information or advertising relating to our products'
          ]
        },
        {
          subtitle: 'Device Information',
          text: 'We use the Device Information to help us screen for potential risk and fraud (particularly your IP address), and more generally to improve and optimize our Site by:',
          list: [
            'Generating analytics about how customers browse and interact with the Site',
            'Assessing the success of our marketing and advertising campaigns',
            'Improving user experience and site functionality'
          ]
        }
      ]
    },
    {
      id: 'sharing',
      title: 'Information Sharing',
      icon: '🤝',
      content: [
        {
          subtitle: 'Third-Party Service Providers',
          text: 'We share your Personal Information with trusted third parties to help us operate our business effectively:',
          list: [
            'Shopify: Powers our online store (view their privacy policy)',
            'Google Analytics: Helps understand how customers use our Site (opt-out available)',
            'Payment processors: Securely process your transactions',
            'Shipping providers: Deliver your orders efficiently'
          ]
        },
        {
          subtitle: 'Legal Requirements',
          text: 'We may share your Personal Information to:',
          list: [
            'Comply with applicable laws and regulations',
            'Respond to subpoenas, search warrants, or other lawful requests',
            'Protect our rights, property, or safety, and that of our users or others'
          ]
        }
      ]
    },
    {
      id: 'marketing',
      title: 'Advertising & Marketing',
      icon: '📢',
      content: [
        {
          subtitle: 'Behavioral Advertising',
          text: 'We may use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you.',
          links: [
            {
              name: 'Facebook Ad Preferences',
              url: 'https://www.facebook.com/settings/?tab=ads'
            },
            {
              name: 'Google Ad Settings',
              url: 'https://www.google.com/settings/ads/anonymous'
            },
            {
              name: 'Bing Ad Personalization',
              url: 'https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads'
            },
            {
              name: 'Digital Advertising Alliance',
              url: 'http://optout.aboutads.info/'
            }
          ]
        },
        {
          subtitle: 'Opt-Out Options',
          text: 'You can opt out of targeted advertising using the links above or by adjusting your browser settings.'
        }
      ]
    },
    {
      id: 'rights',
      title: 'Your Rights',
      icon: '🔒',
      content: [
        {
          subtitle: 'European Residents',
          text: 'If you are a European resident, you have the right to:',
          list: [
            'Access personal information we hold about you',
            'Request correction of inaccurate data',
            'Request deletion of your personal information',
            'Object to processing of your data',
            'Request restriction of processing',
            'Data portability'
          ]
        },
        {
          subtitle: 'Global Rights',
          text: 'All users have the right to:',
          list: [
            'Opt-out of marketing communications',
            'Access their personal data we hold',
            'Request data correction',
            'Withdraw consent where applicable'
          ]
        }
      ]
    },
    {
      id: 'data',
      title: 'Data Security & Retention',
      icon: '💾',
      content: [
        {
          subtitle: 'Security Measures',
          text: 'We implement appropriate technical and organizational security measures to protect your personal information, including:',
          list: [
            'SSL encryption for data transmission',
            'Secure payment processing',
            'Regular security assessments',
            'Limited access to personal data'
          ]
        },
        {
          subtitle: 'Data Retention',
          text: 'We retain your Order Information for our records unless and until you request deletion. Device Information is typically retained for analytics purposes for a limited period.',
          text2: 'Your information may be transferred outside of Europe, including to Canada and the United States, with appropriate safeguards.'
        }
      ]
    },
    {
      id: 'compliance',
      title: 'Compliance & Updates',
      icon: '📝',
      content: [
        {
          subtitle: 'Do Not Track',
          text: 'Please note that we do not alter our Site\'s data collection and use practices when we see a Do Not Track signal from your browser.'
        },
        {
          subtitle: 'Policy Updates',
          text: 'We may update this privacy policy periodically to reflect changes in our practices or for operational, legal, or regulatory reasons. We will notify you of any material changes by posting the new policy on this page.'
        },
        {
          subtitle: 'Children\'s Privacy',
          text: 'Our Site is not intended for individuals under the age of 16. We do not knowingly collect personal information from children under 16.'
        }
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="privacy-page">
      {/* Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-icon">🔒</div>
            <h1>Privacy Policy</h1>
            <p className="subtitle">
              Protecting your personal information is our priority
            </p>
            <div className="last-updated">
              Last updated: {new Date().toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Quick Summary */}
      <section className="privacy-summary">
        <div className="container">
          <div className="summary-cards">
            <div className="summary-card">
              <div className="card-icon">👁️</div>
              <h3>Transparency</h3>
              <p>Clear information about what data we collect and why</p>
            </div>
            <div className="summary-card">
              <div className="card-icon">🛡️</div>
              <h3>Security</h3>
              <p>Industry-standard protection for your personal information</p>
            </div>
            <div className="summary-card">
              <div className="card-icon">🎯</div>
              <h3>Control</h3>
              <p>You have rights and choices about your data</p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container privacy-container">
        <div className="privacy-sidebar">
          <div className="sidebar-card">
            <h3>Quick Navigation</h3>
            <ul className="sidebar-nav">
              {sections.map((section, index) => (
                <li key={section.id}>
                  <button 
                    onClick={() => document.getElementById(section.id)?.scrollIntoView({ behavior: 'smooth' })}
                    className="nav-link"
                  >
                    <span className="nav-icon">{section.icon}</span>
                    {section.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-help">
            <h4>Need Assistance?</h4>
            <p>Have questions about our privacy practices?</p>
            <a href="mailto:hello@theshapesunited.com" className="contact-email">
              hello@theshapesunited.com
            </a>
            <a href="/contact" className="contact-button">Contact Us</a>
          </div>
        </div>

        <div className="privacy-content">
          {/* Introduction */}
          <div className="intro-section">
            <p className="intro-text">
              This Privacy Policy describes how The Shapes United collects, uses, and shares your 
              personal information when you visit or make a purchase from www.theshapesunited.com.
            </p>
            <div className="policy-highlights">
              <div className="highlight-item">
                <strong>Transparency:</strong> We're open about our data practices
              </div>
              <div className="highlight-item">
                <strong>Security:</strong> Your data is protected with industry standards
              </div>
              <div className="highlight-item">
                <strong>Control:</strong> You have choices about your information
              </div>
            </div>
          </div>

          {/* Detailed Sections */}
          {sections.map((section, index) => (
            <section key={section.id} id={section.id} className="policy-section">
              <div className="section-header">
                <div className="section-icon">{section.icon}</div>
                <h2>{section.title}</h2>
              </div>
              
              <div className="section-content">
                {section.content.map((item, itemIndex) => (
                  <div key={itemIndex} className="content-block">
                    {item.subtitle && <h4>{item.subtitle}</h4>}
                    <p>{item.text}</p>
                    {item.text2 && <p>{item.text2}</p>}
                    
                    {item.list && (
                      <ul className="info-list">
                        {item.list.map((listItem, listIndex) => (
                          <li key={listIndex}>{listItem}</li>
                        ))}
                      </ul>
                    )}
                    
                    {item.links && (
                      <div className="link-group">
                        {item.links.map((link, linkIndex) => (
                          <a 
                            key={linkIndex}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="external-link"
                          >
                            {link.name} ↗
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </section>
          ))}

          {/* Mobile Accordion */}
          <div className="mobile-accordion">
            <h3 className="accordion-title">Privacy Details</h3>
            {sections.map((section, index) => (
              <div key={section.id} className="accordion-item">
                <button 
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <span className="accordion-icon">{section.icon}</span>
                  <span>{section.title}</span>
                  <span className="accordion-arrow">
                    {activeAccordion === index ? '−' : '+'}
                  </span>
                </button>
                {activeAccordion === index && (
                  <div className="accordion-content">
                    {section.content.map((item, itemIndex) => (
                      <div key={itemIndex} className="accordion-block">
                        {item.subtitle && <h4>{item.subtitle}</h4>}
                        <p>{item.text}</p>
                        {item.list && (
                          <ul>
                            {item.list.map((listItem, listIndex) => (
                              <li key={listIndex}>{listItem}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <section className="contact-section">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <h3>Contact Our Privacy Team</h3>
              <p>
                For more information about our privacy practices, questions, or to make a complaint, 
                please contact our Privacy Compliance Officer.
              </p>
              
              <div className="contact-details">
                <div className="contact-method">
                  <strong>Email:</strong>
                  <a href="mailto:hello@theshapesunited.com">hello@theshapesunited.com</a>
                </div>
                
                <div className="contact-method">
                  <strong>Mail:</strong>
                  <div className="address">
                    The Shapes United<br />
                    Re: Privacy Compliance Officer<br />
                    PO Box 401, Preston VIC 3072<br />
                    Australia
                  </div>
                </div>
              </div>
              
              <div className="contact-actions">
                <a href="mailto:hello@theshapesunited.com" className="btn-primary">
                  Email Privacy Team
                </a>
                <a href="/contact" className="btn-secondary">
                  Contact Form
                </a>
              </div>
            </div>
          </section>

          {/* Policy Acceptance */}
          <div className="acceptance-section">
            <p className="acceptance-text">
              By using our website and services, you acknowledge that you have read and 
              understood this Privacy Policy.
            </p>
            <div className="policy-version">
              <strong>Policy Version:</strong> 2.0 • Effective Date: {new Date().toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;